import React, { useEffect, useState } from 'react'
import { Button, makeStyles } from "@material-ui/core";
import { ButtonGroup } from '@material-ui/core';
import { ArrowBack, ArrowBackIos, ArrowForwardIos, ArrowForwardIosOutlined, FirstPage, LastPage, NavigateNext } from '@material-ui/icons';
import { TemplateIcons } from '../../comps/Settings/invoice-settings/invoice-templates/TemplabeTable';
import useFetchURL from '../Hooks/useFetchURL';
import { uri } from '../../help/Api';
import printJS from 'print-js';
import { generateDocument } from '../../comps/Settings/invoice-settings/invoice-templates/test-template';

const useStyles = makeStyles(theme => ({
    root: {
        margin: theme.spacing(0.5)
    },
    label: {
        textTransform: 'none'
    }
}))

export default function PrintingButtons(props) {
    
    const {color, disabled, onClick, ...other } = props
    const url = uri+'templates';
    const {data:templates, fetching,} = useFetchURL({...{url, dependencyArray:[]}});
    const classes = useStyles();
    const SelectedIconComponent = (selectedIcon) => {
      const IconCompo =
      TemplateIcons.find((icon) => icon.name === selectedIcon)?.component || null;
      return IconCompo != null ? <IconCompo /> : <></>;
    };

    const buttons = [
      !fetching && templates &&(
        templates.map(temp=>{
          return <Button key={temp.Id}
            style={{color:color, borderRadius:0, borderBottom:'solid 1px white'}}
            onClick={()=>{
              console.log("i am in templates", onClick)
              onClick(temp.FileName);
            }}
            disabled={props?.disabled}
          >
            {SelectedIconComponent(temp.IconName)}
        </Button>})
      )
      ];
    return (
        <ButtonGroup
            orientation="horizontal"
            aria-label="horizontal primary button group"
            // style={{marginTop:'-10px', backgroundColor: '#cd5c5c'}}
            
            other
        >
            {buttons}
      </ButtonGroup>
    )
}